/** 获取期货合约 */
import Vue from 'vue'

/**
 * 获取期货合约
 * @param data
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchFutContract(data) {
  const { contractCodes, lang } = data
  return Vue.http.post(`~futContract/fut/contract/codes?lang=${lang}`, {
    contractCodes
  })
}

/**
 * 获取期货概要信息
 * @param {array} contractCodeList 合约号列表
 * @returns {PromiseLike<HttpResponse>}
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchFutBrief(contractCodeList) {
  return Vue.http.post('~futNews/fut/marketpricebrief', { contractCodeList })
}

/**
 * 获取期货分价信息
 * @param { string } code - 期货合约代码
 * @param { number } sortType - 排序类型
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchFutTradePrices(code, sortType = 0) {
  return Vue.http.get('~futNews/fut/pricepoints', {
    params: { contractCode: code, sortType }
  })
}
